// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2dk0v","container":"styles_container__1anq4","title":"styles_title__1XNgh","wrapper":"styles_wrapper___WukW","answer":"styles_answer__1-dCo"};